import type { BoxProps } from '@mui/material/Box';

import { CardMedia } from '@mui/material';
import Box from '@mui/material/Box';
import { m } from 'framer-motion';
import { useState } from 'react';
import { MotionContainer } from 'src/components/animate';
import { RemoteImage } from '@/types';

// ----------------------------------------------------------------------

type HeroHomeBackgroundProps = BoxProps & {
  media?: {
    preview?: RemoteImage;
    video?: { link?: string };
  };
};

export function HeroBackground({ sx, media, ...other }: HeroHomeBackgroundProps) {

  const VideoCard = () => (
    <Box
      component={m.div}
      width="1440"
      height="1080"
      sx={[{ position: 'relative', width: 1, height: 1, overflow: 'hidden' }]}>
      {/* Background Image (shows while video loads) */}
      {media?.preview?.url && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1,
            width: '100%',
            height: '100%',
            backgroundImage: `url(${media?.preview?.url})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
      )}

      {/* Video Element */}
      <CardMedia
        component="video"
        image={media?.video?.link}
        title="Autoplay Video"
        autoPlay
        muted
        loop
        sx={{
          zIndex: 2,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          transition: 'opacity 0.5s ease',
        }}
      />

      {/* Color Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#003A8C',
          opacity: 0.65,
          zIndex: 2,
        }}
      />
    </Box>
  );

  return (
    <MotionContainer>
      <Box
        sx={[
          (theme) => ({
            top: 0,
            left: 0,
            width: 1,
            height: 1,
            position: 'absolute',
          }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        {...other}>
        {VideoCard()}
      </Box>
    </MotionContainer>
  );
}
